import { PhotoSwipe as PhotoSwipe$1 } from 'react-photoswipe';
import propTypes from 'prop-types';
import React from 'react';

var PhotoSwipe = function PhotoSwipe(_ref) {
  var _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    _ref$sources = _ref.sources,
    sources = _ref$sources === void 0 ? [] : _ref$sources,
    _ref$initialIndex = _ref.initialIndex,
    initialIndex = _ref$initialIndex === void 0 ? 0 : _ref$initialIndex,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose;
  var items = sources.map(function (source) {
    return {
      src: source,
      w: 0,
      h: 0
    };
  });
  var options = {
    index: initialIndex,
    shareEl: false,
    counterEl: false
  };
  function gettingData(instance, index, item) {
    if (item.w < 1 || item.h < 1) {
      // unknown size
      var img = new Image();
      img.onload = function () {
        // will get size after load
        item.w = this.width; // set image width
        item.h = this.height; // set image height
        instance.invalidateCurrItems(); // reinit Items
        instance.updateSize(true); // reinit Items
      };
      img.src = item.src; // let's download image
    }
  }
  return /*#__PURE__*/React.createElement(PhotoSwipe$1, {
    isOpen: isOpen,
    items: items,
    options: options,
    onClose: onClose,
    gettingData: gettingData
  });
};
PhotoSwipe.propTypes = {
  isOpen: propTypes.bool,
  sources: propTypes.arrayOf(propTypes.string),
  initialIndex: propTypes.number,
  onClose: propTypes.func,
  getThumbBounds: propTypes.func
};

export { PhotoSwipe };
